import React from "react"
import styled from "styled-components"
import { rem } from "../../utils/styling"
import {
  DEVICE_TYPE_DESKTOP,
  DEVICE_TYPE_MOBILE,
  useDeviceType,
} from "../../utils/deviceType"

const Wrapper = styled.div`
  margin: ${rem(20)}rem 0 ${rem(10)}rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const HWContainer = styled.div`
  width: 100%;
  text-align: center;
`

const HWSection = styled.div`
  width: 100%;
`
const Title = styled.h3`
  background-color: #f5576c;
  background-image: ${props =>
    props.cardIndex == 0
      ? "linear-gradient(87.85deg, #f5576c -3.16%, #f093fb 109.01%)"
      : props.cardIndex == 1
      ? "linear-gradient(87.85deg, #764BA2 -3.16%, #667EEA 109.01%)"
      : "linear-gradient(87.95deg, #00C6FB -3.15%, #005BEA 124.37%)"};
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  font-size: ${rem(24)}rem;
  padding: ${rem(20)}rem 0;
  text-align: center;
  @media screen and (min-width: 1100px) {
    font-size: ${rem(28)}rem;
  }
`

const HWText = styled.p`
  color: #000;
  font-weight: 300;
  text-align: center;
  font-size: 20px;
  line-height: 37px;
  opacity: 0.6;
  margin: 0 auto;
  @media screen and (min-width: 1100px) {
    font-size: ${rem(20)}rem;
    width: 50%;
  }
`

const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${rem(40)}rem 0;
  @media screen and (min-width: 1100px) {
    flex-direction: row;
  }
`

const TimelineTextContainer = styled.div`
  flex: 1;
  padding: 0;
  @media screen and (min-width: 1100px) {
    padding: ${rem(70)}rem 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`
const TimelineTitle = styled.h3`
  color: #212121;
  font-size: ${rem(18)}rem;
  font-weight: 800;
  text-align: center;
  max-width: 100%;

  @media screen and (min-width: 1100px) {
    font-size: ${rem(20)}rem;
    text-align: right;
    align-items: flex-end;
    max-width: 70%;
  }
`

const TimelineText = styled.p`
  font-size: ${rem(13)}rem;
  text-align: center;
  line-height: 27px;
  padding-top: ${rem(10)}rem;
  @media screen and (min-width: 1100px) {
    float: right;
    width: ${rem(350)}rem;
    padding-top: 0;
    font-size: 14px;
    line-height: 27px;
    text-align: right;
    color: #000000;
    opacity: 0.5;
  }
`

const SeparatorContainer = styled.div`
  position: relative;
`

const MobileSeparatorContainer = styled(SeparatorContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${rem(10)}rem;
`

const TimelineVerticalSeparator = styled.li`
  padding: 0;
  margin: 0 ${rem(40)}rem;
  background: #fcb13f;
  display: block;
  height: ${rem(550)}rem;
  width: ${rem(2)}rem;
  background: ${props =>
    props.last
      ? "linear-gradient(#fff, #aaa, #aaa)"
      : "linear-gradient(#fff, #aaa, #fff)"};
`
const MobileTimelineVerticalSeparator = styled.div`
  width: ${rem(2)}rem;
  background: linear-gradient(#fff, #aaa);
  height: ${rem(40)}rem;
`

const MobileSeparator = styled(MobileTimelineVerticalSeparator)`
  background: linear-gradient(#aaa, #fff);
  margin: ${rem(250)}rem 0 0;
  height: ${rem(40)}rem;
`

const TimelineBullet = styled.div`
  border: 2px solid #f5576c;
  background-color: #fff;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  position: absolute;
  top: ${rem(76)}rem;
  left: 39%;
`

const MobileTimelineBullet = styled(TimelineBullet)`
  left: calc(50% - 8px);
  top: ${rem(40)}rem;
`

const TimelineImageContainer = styled.div`
  flex: 1;
  padding: ${rem(30)}rem 0 0;
  position: relative;
  @media screen and (min-width: 1100px) {
  }
`

const TimelineImage = styled.img`
  width: 100%;
  position: absolute;
  left: 0;
  top: ${rem(30)}rem;
  @media screen and (min-width: 1100px) {
    width: 90%;
    left: -${rem(10)}rem;
  }
`
const TimelineImageTwo = styled.img`
  width: 80%;
  position: absolute;
  right: -${rem(10)}rem;
  top: ${rem(120)}rem;
  @media screen and (min-width: 1100px) {
    right: ${rem(0)}rem;
  }
`

const TimelineMobileImage = styled.img`
  width: 35%;
  position: absolute;
  right: ${rem(10)}rem;
  top: ${rem(50)}rem;
`

const HowItWorksCard = ({
  title,
  text,
  timelineTitle,
  tiimelineText,
  desktopImage,
  mobileImage,
  desktopImage2,
  cardIndex,
  arrLen,
}) => {
  const deviceType = useDeviceType()
  return (
    <Wrapper>
      <HWContainer>
        <HWSection>
          <Title cardIndex={cardIndex}>{title}</Title>
          <HWText>{text}</HWText>
          {deviceType === DEVICE_TYPE_MOBILE && (
            <MobileSeparatorContainer>
              <MobileTimelineVerticalSeparator />
              <MobileTimelineBullet />
            </MobileSeparatorContainer>
          )}
          <Timeline>
            <TimelineTextContainer>
              <TimelineTitle>{timelineTitle}</TimelineTitle>
              <TimelineText>{tiimelineText}</TimelineText>
            </TimelineTextContainer>
            {deviceType === DEVICE_TYPE_DESKTOP && (
              <SeparatorContainer>
                <TimelineVerticalSeparator last={cardIndex === arrLen - 1} />
                <TimelineBullet />
              </SeparatorContainer>
            )}
            <TimelineImageContainer>
              <TimelineImage src={desktopImage} />
              {mobileImage && <TimelineMobileImage src={mobileImage} />}
              {desktopImage2 && <TimelineImageTwo src={desktopImage2} />}
            </TimelineImageContainer>
          </Timeline>
        </HWSection>
        {cardIndex !== arrLen - 1 && deviceType === DEVICE_TYPE_MOBILE && (
          <MobileSeparatorContainer>
            <MobileSeparator />
          </MobileSeparatorContainer>
        )}
      </HWContainer>
    </Wrapper>
  )
}

export default HowItWorksCard
